import { PaymentIntentResult } from "@stripe/stripe-js";
import { GetTicketQuantities } from "../../../connection/live-events/event";
import { GetPrivacyPolicy } from "../../../connection/privacy-policy";
import { CompleteProfile, IProfileComplete, IRegistrationRequest, Register, CreateStripeIntent, IStripeOptions, IStripeData, ReRegister, ReRegisterCheck, IReRegistrationRequest } from "../../../connection/registration";
import { GetTermsConditions } from "../../../connection/terms-conditions";
import { GetUserSession, UpdateUserSessionEndTime } from "../../../connection/user-sessions";
import { Action, AsyncAction } from "../../../types/actions";
import { BlProfile, BrandliveEvent } from "../../../types/working-model";
import { LoadEventBundle, LoadPage } from "../../utils/page-loader";

export const SET_BL_USER = "SET_BL_USER";
export function setBlUser(user: BlProfile | null): Action {
	return {
		type: SET_BL_USER,
		payload: user,
	};
}

export const REGISTER = "REGISTER";
export function register(request: IRegistrationRequest, eventUuid: string, bl_token?: string): AsyncAction {
	return {
		type: REGISTER,
		promise: Register(request, eventUuid, bl_token)
	};
}

export const GET_USER_SESSION = "GET_USER_SESSION";
export function getUserSession(sessionId: number, token?: string, registration_id?: string): AsyncAction {
	return {
		type: GET_USER_SESSION,
		promise: GetUserSession(sessionId, token, registration_id)
	};
}

export const UPDATE_USER_SESSION_END_TIME = "UPDATE_USER_SESSION_END_TIME";
export function updateUserSessionEndTime(session: string): AsyncAction {
	return {
		type: UPDATE_USER_SESSION_END_TIME,
		promise: UpdateUserSessionEndTime(session)
	};
}

export const SET_USER_SESSION = "SET_USER_SESSION";
export function setUserSession(userSession: string): Action {
	return {
		type: SET_USER_SESSION,
		payload: userSession
	};
}

export const SET_REGISTRATION_STEP = "SET_REGISTRATION_STEP";
export function setRegistrationStep(step: number): Action {
	return {
		type: SET_REGISTRATION_STEP,
		payload: step
	};
}

export const COMPLETE_PROFILE = "COMPLETE_PROFILE";
export function completeRegistrationProfile(request: IProfileComplete, token?: string): AsyncAction {
	return {
		type: COMPLETE_PROFILE,
		promise: CompleteProfile(request, token)
	};
}

export const CREATE_STRIPE_INTENT = "CREATE_STRIPE_INTENT";
export function createStripeIntent(options: IStripeOptions, data: IStripeData): AsyncAction {
	return {
		type: CREATE_STRIPE_INTENT,
		promise: CreateStripeIntent(options, data),
	};
}

export const FINISHED_STRIPE_PAYMENT = "FINISHED_STRIPE_PAYMENT";
export function finishedStripePayment(result: PaymentIntentResult): Action {
	return {
		type: FINISHED_STRIPE_PAYMENT,
		payload: result.paymentIntent,
	};
}

export const TOGGLE_REGISTRATION_MODAL = "TOGGLE_REGISTRATION_MODAL";
export function toggleRegistrationModal(sessionUuid: string | null): Action {
	return {
		type: TOGGLE_REGISTRATION_MODAL,
		payload: sessionUuid,
	};
}

export const SET_BL_PROFILE_TOKEN = "SET_BL_PROFILE_TOKEN";
export function setBlProfileToken(token: string): Action {
	return {
		type: SET_BL_PROFILE_TOKEN,
		payload: token,
	};
}

export const SET_COMPLETED_SURVEY_QUESTIONS = "SET_COMPLETED_SURVEY_QUESTIONS";
export function setCompletedSurveyQuestion(question: number, option: number): Action {
	return {
		type: SET_COMPLETED_SURVEY_QUESTIONS,
		payload: { question, option }
	};
}

export const SET_COMPLETED_MULTI_QUESTIONS = "SET_COMPLETED_MULTI_QUESTIONS";
export function setCompletedMultiQuestion(question: number, options: { [key: number]: number }): Action {
	return {
		type: SET_COMPLETED_MULTI_QUESTIONS,
		payload: { question, options }
	};
}

export const SET_COMPLETED_TEXT_QUESTIONS = "SET_COMPLETED_TEXT_QUESTIONS";
export function setCompletedTextQuestion(question: number, answer: string): Action {
	return {
		type: SET_COMPLETED_TEXT_QUESTIONS,
		payload: { question, answer }
	};
}

export const RESET_SURVEY = "RESET_SURVEY";
export function resetSurvey(questions: number[]): Action {
	return {
		type: RESET_SURVEY,
		payload: questions
	};
}

export const GET_LIVE_TERMS_CONDITIONS = "GET_LIVE_TERMS_CONDITIONS";
export function getLiveTermsConditions(term_id: number): AsyncAction {
	return {
		type: GET_LIVE_TERMS_CONDITIONS,
		promise: GetTermsConditions(term_id)
	};
}

export const GET_LIVE_PRIVACY_POLICY = "GET_LIVE_PRIVACY_POLICY";
export function getLivePrivacyPolicy(policy: number): AsyncAction {
	return {
		type: GET_LIVE_PRIVACY_POLICY,
		promise: GetPrivacyPolicy(policy)
	};
}
export const UPDATE_EVENT_BUNDLE = "UPDATE_EVENT_BUNDLE";
export function updateEventBundle(eventBundle: BrandliveEvent): Action {
	return {
		type: UPDATE_EVENT_BUNDLE,
		payload: eventBundle
	};
}

export const LOAD_EVENT_BUNDLE = "LOAD_EVENT_BUNDLE";
export function loadEventBundle(channelHost: string, eventUrl: string): AsyncAction {
	return {
		type: LOAD_EVENT_BUNDLE,
		promise: LoadEventBundle(channelHost, eventUrl)
	};
}

export const LOAD_PAGE = "LOAD_PAGE";
export function loadPage(eventUuid: BrandliveEvent): AsyncAction {
	return {
		type: LOAD_PAGE,
		promise: LoadPage(eventUuid)
	};
}

export const GET_TICKET_INFO = "GET_TICKET_INFO";
export function getTicketQuantities(channelHost: string, eventUrl: string): AsyncAction {
	return {
		type: GET_TICKET_INFO,
		promise: GetTicketQuantities(channelHost, eventUrl),
	};
}

export const RE_REGISTER = "RE_REGISTER";
export function reRegister(params: IReRegistrationRequest): AsyncAction {
	return {
		type: RE_REGISTER,
		promise: ReRegister(params)
	};
}

export const RE_REGISTER_CHECK = "RE_REGISTER_CHECK";
export function reRegisterCheck(eventUuid: string, code: string): AsyncAction {
	return {
		type: RE_REGISTER_CHECK,
		promise: ReRegisterCheck(eventUuid, code)
	};
}